export default {
    fund: [{
            "title": "关于开放式基金份额登记，以下表述错误的是（　　）。",
            "question": "A. 基金管理人应当自收到投资者的申购、赎回申请之日起3个工作日内，对该申购、赎回申请的有效性进行确认\nB. 注册登记机构完成对基金份额持有人的基金份额登记后需将登记数据发送至基金托管人\nC. 对于投资者的申购和赎回申请注册登记机构根据T+1日的基金份额净值进行确认处理\nD. 基金份额申购和赎回的资金清算是注册登记机构根据确认的投资者申购和赎回数据信息进行的",
            "answer": "C",
            "explain": "本题考查开放式基金份额登记。T日，投资者的申购和赎回申请信息通过代销机构网点传送至代销机构总部，由代销机构总部将本代销机构的申购和赎回申请信息汇总后统一传送至注册登记机构。T+1日，注册登记机构根据T日各代销机构的申购和赎回申请数据及T日的基金份额净值统一进行确认处理（C选项错误），并将确认的基金份额登记至投资者的账户，然后将确认后的申购和赎回数据信息下发至各代销机构，各代销机构再下发至各所属网点，同时，注册登记机构也将登记数据发送至基金托管人。"
        },
        {
            "title": "某公募基金管理公司从业人员张某在和基金经理李某闲聊过程中，得知基金经理李某的配偶在进行股票买卖交易，但李某并未向公司申报登记。张某随后向公司报告了此事。以下说法正确的是（　　）。",
            "question": "A. I、IV\nB. I、III\nC. II、IV\nD. II、III",
            "questions": "I. 张某违反了诚实守信的职业道德<br>II. 张某做法符合守法合规的要求<br>III. 李某违反了守法合规的要求<br>IV. 李某本人未参与，符合守法合规的要求",
            "answer": "D",
            "explain": "本题考查守法合规的基本要求。根据《证券投资基金法》规定，公开募集基金的基金管理人的董事、监事、高级管理人员及其他从业人员，其本人、配偶、利害关系人进行证券投资应当向基金管理人申报。"
        },
        {
            "title": "某证监局对辖区内甲基金销售机构进行现场检查时发现，甲未建立投资者适当性管理制度与方法等导致执行中没有统一标准，请问甲违反了基金销售适用性的哪一条原则（　　）。",
            "question": "A. 有效性原则\nB. 差异性原则\nC. 及时性原则\nD. 全面性原则",
            "answer": "A",
            "explain": "本题考查基金销售机构实施基金销售适用性的指导原则。基金销售适用性的原则包括：（1）投资者利益优先原则；"
        },
        {
            "title": "私募基金管理人依照规定，需要如实向投资者披露的基金信息包括（　　）。",
            "question": "A. I、II、IV\nB. I、II\nC. I、II、III\nD. I、II、III、IV",
            "questions": "I. 基金承担的费用<br>II. 基金的资产负债情况<br>III. 基金的投资情况<br>IV. 基金可能存在的利益冲突情况",
            "answer": "D",
            "explain": "《私募投资基金监督管理暂行办法》规定，私募基金管理人、私募基金托管人应当按照合同约定，如实向投资者披露基金投资、资产负债、投资收益分配、基金承担的费用和业绩报酬、可能存在的利益冲突情况以及可能影响投资者合法权益的其他重大信息，不得隐瞒或者提供虚假信息。"
        },
        {
            "title": "在我国，证券投资基金的基金管理人、基金托管人和基金持有人之间的权利义务由（　　）确定。",
            "question": "A. 基金公司章程\nB. 基金合同\nC. 基金托管协议\nD. 基金招募说明书",
            "answer": "B",
            "explain": "本题考查基金合同的概念。基金合同是约定基金管理人、基金托管人和基金份额持有人权利义务关系的重要法律文件。投资者交纳基金份额认购款项时，即表明其对基金合同的承认和接受，此时基金合同成立。"
        },
        {
            "title": "应当对基金投资人进行风险承受能力调查和评价的机构或部门包括（　　）。",
            "question": "A. II、III\nB. I、II\nC. II、IV\nD. I、IV",
            "questions": "I. 基金管理人的自销业务部门<br>II. 基金销售机构<br>III. 第三方基金评级与评价机构<br>IV. 基金托管人的风险控制部门",
            "answer": "B",
            "explain": "本题考查基金投资人风险承受能力。调查和评价的主体基金销售机构应当建立基金投资人调查制度，制定科学合理的调查方法和清晰有效的作业流程，对基金投资人的风险承受能力进行调查和评价。I. II均属于对基金投资人进行风险承受能力调查和评价的机构或部门。"
        },
        {
            "title": "关于ETF基金上市交易价格的涨跌幅，以下表述正确的是（　　）。",
            "question": "A. 上市首日无涨跌幅限制，下一交易日起实行涨跌幅限制，涨幅比例为10%\nB. 自上市首日起实行涨跌幅限制，涨跌幅比例为10%\nC. 自上市首日起实行涨跌幅限制，涨跌幅比例为5%\nD. 上市首日无涨跌幅限制，下一交易日起实行涨跌幅限制，涨幅比例为5%",
            "answer": "B",
            "explain": "本题考查ETF份额的上市交易。ETF合同生效后，基金管理人可向证券交易所申请上市。ETF上市后二级市场的交易与封闭式基金类似，要遵循下列交易规则：（1）基金上市首日的开盘参考价为前一工作日基金份额净值；（2）基金实行价格涨跌幅限制，涨跌幅比例为10%（不是5%），自上市首日起实行（不是下一交易日）；（3）基金买入申报数量为100份或其整数倍，不足100份的部分可以卖出；（4）基金申报价格最小变动单位为0.001元。"
        },
        {
            "title": "关于公开募集基金应当公开披露的信息不包括（　　）。",
            "question": "A. 基金财产的资产组合季度报告及中期和年度报告\nB. 基金托管协议\nC. 证券品种的交易记录\nD. 基金累计份额净值",
            "answer": "C",
            "explain": "本题考查基金信息披露的内容。基金信息披露的内容包括：（1）基金招募说明书；（2）基金合同；（3）基金托管协议(B项正确)；"
        },
        {
            "title": "私募证券投资基金的投资范围包括（　　）。",
            "question": "A. I、II、III、IV\nB. I、IV\nC. II、III、IV\nD. I、II、III",
            "questions": "I. 未公开发行的股权凭证<br>II. 基金<br>III. 债券<br>IV. 证券衍生品种",
            "answer": "C",
            "explain": "本题考查证券投资基金。证券投资基金是投资基金中最主要的一种类别，可分为公募证券投资基金和私募证券投资基金。其中，私募证券投资基金主要投资于传统金融资产。"
        },
        {
            "title": "私募基金管理人、私募基金托管人应当按照合同约定，如实向投资者披露的信息包括（　　）。",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. I、II、IV",
            "questions": "I. 基金承担的费用<br>II. 基金的资产负债情况<br>III. 基金的投资情况<br>IV. 基金可能存在的利益冲突情况",
            "answer": "D",
            "explain": "本题考查非公开募集基金的信息披露。《私募投资基金监督管理暂行办法》规定，私募基金管理人、私募基金托管人应当按照合同约定，如实向投资者披露基金投资、资产负债、投资收益分配、基金承担的费用和业绩报酬、可能存在的利益冲突情况以及可能影响投资者合法权益的其他重大信息，不得隐瞒或者提供虚假信息。"
        },
        {
            "title": "在现阶段，证券投资基金的基金管理人、基金托管人和基金持有人之间的权利义务由（　　）确定。",
            "question": "A. 基金公司章程\nB. 基金合同\nC. 基金托管协议\nD. 基金招募说明书",
            "answer": "B",
            "explain": "本题考查基金合同的概念。基金合同是约定基金管理人、基金托管人和基金份额持有人权利义务关系的重要法律文件。投资者交纳基金份额认购款项时，即表明其对基金合同的承认和接受，此时基金合同成立。"
        },
        {
            "title": "关于私募基金募集结算资金和私募基金募集结算资金专用账户，以下表述正确的是（　　）。",
            "question": "A. I、III、IV\nB. I、II、III、IV\nC. I、II、III\nD. I、II、IV",
            "questions": "I. 该专用账户用于统一归集私募基金募集结算资金<br>II. 募集结算资金，从投资者资金账户划出，到达私募基金财产账户或托管资金账户之前，属于基金资产<br>III. 投资者赎回私募基金的资金，应当经过私募基金募集结算资金专用账户，原路返还<br>IV. 私募基金募集结算资金专用账户可由销售机构开立",
            "answer": "A",
            "explain": "本题考查基金销售的原则性要求。I. II项表述正确，销售机构或相关合同约定的责任主体应当开立私募基金募集结算资金专用账户，用于统一归集私募基金募集结算资金、向投资者分配收益、给付赎回款项以及分配基金清算后的剩余基金财产等，确保资金原路返还。"
        },
        {
            "title": "可开展公募开放式基金注册登记业务的机构包括（　　）。",
            "question": "A. I、III\nB. I、II、III、IV\nC. I、II、III\nD. I、II",
            "questions": "I. 基金管理人<br>II. 基金托管人<br>III. 中国证券登记结算有限责任公司<br>IV. 基金代销机构",
            "answer": "A",
            "explain": "本题考查我国开放式基金注册登记业务的办理机构。《证券投资基金法》规定，开放式基金的注册登记业务可以由基金管理人办理，也可以委托中国证监会认定的其他机构办理。"
        },
        {
            "title": "基金管理人为确保会计核算系统的正常运转，所采取会计控制措施应当包括（　　）。",
            "question": "A. III、IV\nB. I、II\nC. I、IV\nD. I、II、III、IV",
            "questions": "I. 建立凭证制度<br>II. 建立复核制度<br>III. 建立成本控制及业绩考核制度<br>IV. 建立会计档案保管和财务交接制度",
            "answer": "D",
            "explain": "本题考查会计系统控制。基金管理人应当采取适当的会计控制措施，以确保会计核算系统的正常运转："
        },
        {
            "title": "T日投资者发起申购或赎回我国境内基金，关于基金申购和赎回的资金结算，以下表述错误的是（　　）。",
            "question": "A. 货币市场基金的赎回资金一般T+1日即可从基金的银行存款账户划出，最快可在当天到达投资者资金账户\nB. 基金份额申购和赎回的资金清算是销售机构根据投资者申购和赎回数据进行的\nC. 申购款一般能在T+2日内到达基金的银行存款账户\nD. 赎回款一般于T+3内从基金的银行存款账户划出相似",
            "answer": "B",
            "explain": "本题考查基金申购和赎回的资金结算。基金份额申购和赎回的资金清算是注册登记机构根据确认的投资者申购和赎回数据信息进行的。"
        },
        {
            "title": "投资人持有的公募基金所投资的所有股票明细，可以在该基金的（　　）中查询。",
            "question": "A. 基金季度报告\nB. 基金合同\nC. 基金月度报告\nD. 基金年度报告",
            "answer": "D",
            "explain": "本题考查基金年度报告中应披露的内容。D选项说法正确，基金年度报告中的基金投资组合报告的披露，应披露期末按市值占基金资产净值比例大小排序的所有股票明细。"
        },
        {
            "title": "关于道德的论述，以下不正确的是（　　）。",
            "question": "A. 社会经济基础和社会关系的不同，决定了道德的差异性\nB. 道德对全体社会成员具有强制性的作用\nC. 道德规范虽然是具体的，但仍有层次的划分\nD. 随着社会经济基础的变化，属于意识形态的道德也会发生相应变化",
            "answer": "B",
            "explain": "本题考查道德的概述。A选项正确，不同的社会有不同的道德。道德是由一定的社会经济基础决定的，是一定社会关系的反映。因此，社会经济基础和社会关系的不同就决定了道德的差异性。B选项错误，相比法律，道德的调整手段更多，但均不具有强制性。C选项正确，道德规范虽然是具体的，但仍有层次的划分。有些规范内涵比较丰富，具有一定的概括性，可以称为道德原则，在道德原则之下通常包含若干更为具体的道德规则。"
        },
        {
            "title": "关于基金销售机构的基金客户档案管理与保密工作，以下说法错误的是（　　）。",
            "question": "A. 应明确基金份额持有人信息的维护和使用权限\nB. 应建立严格的基金份额持有人信息管理制度和保密制度\nC. 必须实行信息技术开发、运营维护、业务操作等人员岗位分离制度\nD. 为保障基金份额持有人信息的安全，须由信息技术负责人兼任信息安全负责人",
            "answer": "D",
            "explain": "本题考查基金客户档案管理与保密。A选项说法正确，基金客户档案管理与保密应明确对基金份额持有人信息的维护和使用权限并留存相关记录。B选项说法正确，基金客户档案管理与保密应建立严格的基金份额持有人信息管理制度和保密制度，及时维护、更新基金份额持有人的信息。C选项说法正确，基金客户档案管理与保密应实行信息技术开发、运营维护、业务操作等人员岗位分离制度，限制信息技术开发、运营维护等技术人员介入实际的业务操作。"
        },
        {
            "title": "关于基金代销机构对基金管理人进行审慎调查，以下表述正确的是（　　）。",
            "question": "A. I、II、III\nB. I、III、IV\nC. I、II、III、IV\nD. II、III、IV",
            "questions": "I. 需了解基金管理人的诚信状况，经营管理能力<br>II. 需了解基金管理人投资管理能力、产品设计能力<br>III. 需在执行审慎调查方法和流程时，尽力减少主观因素和人力因素的干扰<br>IV. 不得使用基金管理人提供的信息，应当独立调查",
            "answer": "A",
            "explain": "本题考查基金的售渠道审慎调查的内容。基金代销机构通过对基金管理人进行审慎调查，了解基金管理人的诚信状况、经营管理能力(I项正确)、投资管理能力、产品设计能力(II项正确)和内部控制情况，并可将调查结果作为是否代销该基金管理人的基金产品或是否向基金投资人优先推介该基金管理人的重要依据。"
        },
        {
            "title": "投资基金是资产管理的主要方式之一，其特征是（　　）。",
            "question": "A. I、II、IV\nB. I、II\nC. I、II、III、IV\nD. I、II、III",
            "questions": "I. 组合投资<br>II. 专业管理<br>III. 利益共享<br>IV. 风险自担",
            "answer": "D",
            "explain": "本题考查投资基金的特点。证券投资基金的基本特点包括："
        }, {
            "title": "下列属于股票、债券型开放式基金申购赎回原则的是（　　）。",
            "question": "A. I、III\nB. II、IV\nC. II、III\nD. I、IV",
            "questions": "I. 未知价原则<br>II. 已知价原则<br>III. 份额申购、份额赎回原则<br>IV. 金额申购、份额赎回原则",
            "answer": "D",
            "explain": "本题考查股票、债券基金的申购和赎回原则。申购是指投资者在开放式基金合同生效后，申请购买基金份额的行为；赎回是指投资者要求基金管理人购回其所持有的基金份额的行为。股票基金、债券基金的申购和赎回原则包括："
        },
        {
            "title": "关于私募基金管理人登记和私募基金备案，以下说法正确的是（　　）。",
            "question": "A. 私募基金管理人登记制度的目的在于通过健全的行政许可制度规范私募行业\nB. 私募基金管理人登记制度的目的之一在于为依法登记的基金管理人增信\nC. 私募基金的备案应当在基金募集完毕之后进行\nD. 私募基金管理人未在中国证券投资基金业协会审批不得成立",
            "answer": "C",
            "explain": "本题考查私募基金管理人和私募基金备案的内容。A、B选项说法错误，私募基金的基金管理人登记制度的目的在于防止滥用基金或者管理人的名义进行非法集资等违法活动。C选项说法正确，各类私募基金募集完毕，私募基金管理人应当根据基金业协会的规定，报送相关基本信息，办理基金备案手续。D选项说法错误，我国对于非公开募集基金的基金管理人没有严格的市场准入限制，担任非公开募集基金的基金管理人无须中国证监会审批，而实行登记制度，即非公开募集基金的基金管理人只需向基金业协会登记即可。"
        },
        {
            "title": "基金管理公司风险管理的组织架构包括（　　）。",
            "question": "A. I、II、III\nB. I、II、IV\nC. I、II、III、IV\nD. II、III、IV",
            "questions": "I. 董事会及其下设的风险管理专门委员会<br>II. 公司管理层及其设立的履行风险管理职能的委员会<br>III. 风险管理职能部门或岗位<br>IV. 各业务部门",
            "answer": "C",
            "explain": "本题考查组织架构职能。I项，可授权董事会下设的风险管理委员会或其他专门委员会履行相应的风险管理和监督职责。"
        },
        {
            "title": "某基金公司管理人及其从业人员违反《私募投资基金监督管理暂行办法》，中国证监会及其派出机构可以采取以下行政监管措施（　　）。",
            "question": "A. I、II、III、IV\nB. I、III、IV\nC. I、II、IV\nD. I、II、III",
            "questions": "I. 责令改正<br>II. 监管谈话<br>III. 出示警示函<br>IV. 公开谴责",
            "answer": "A",
            "explain": "本题考查中国证监会对基金市场的监管措施的主要内容。根据《私募投资基金监督管理暂行办法》，私募基金管理人、私募基金托管人、私募基金销售机构及其他私募服务机构及其从业人员违反法律、行政法规规定，中国证监会及其派出机构可以对其采取责令改正、监管谈话、出具警示函、公开谴责等行政监管措施。"
        },
        {
            "title": "关于基金投资人的风险承受能力调查和评价，以下表述错误的是（　　）。",
            "question": "A. 基金销售机构应在基金投资人首次开立基金交易账户时或首次购买基金产品时对基金投资人进行风险承受能力调查和评价\nB. 基金销售机构应对已经购买了基金产品的基金投资人进行风险承受能力的追溯调查和评价\nC. 在对基金投资人的风险承受能力进行调查和评价之前，基金销售机构应当执行基金投资人身份认证程序\nD. 为保证所获得信息的真实性和准确性，基金销售机构必须采用当面的形式对基金投资人进行风险承受能力调查",
            "answer": "D",
            "explain": "本题考查基金投资人风险承受能力调查和评价。A选项正确，基金销售机构应当在基金投资人首次开立基金交易账户时或首次购买基金产品时对基金投资人的风险承受能力进行调查和评价。B选项正确，对已经购买了基金产品的基金投资人，基金销售机构也应当追溯调查，评价该基金投资人的风险承受能力。C选项正确，在对基金投资人的风险承受能力进行调查和评价前，基金销售机构应当执行基金投资人身份认证程序，核查基金投资人的投资资格，切实履行反洗钱等法律义务。D选项错误，基金销售机构可以采用当面、信函、网络或对已有的客户信息进行分析等方式对基金投资人的风险承受能力进行调查，并向基金投资人及时反馈评价的结果。"
        },
        {
            "title": "对于基金公司某一投资组合风险管理的第一责任人的是（　　）。",
            "question": "A. 研究总监\nB. 基金经理\nC. 风控总监\nD. 投资总监",
            "answer": "B",
            "explain": "本题考查基金公司风险管理部门。《基金管理公司风险管理指引》对基金公司构建风险管理体系进行了详细的规定，特别强调全员风险管理理念，员工是其岗位风险管理的直接责任人，并负责具体风险管理职责的实施。基金经理(投资经理)是相应投资组合风险管理的第一责任人。"
        },
        {
            "title": "ETF基金管理人应于（　　）向证券交易所、证券登记结算机构提供ETF的申购清单和赎回清单。",
            "question": "A. 每日开市前\nB. 每日收盘前15分钟\nC. 每日开市后\nD. 每日收盘后15分钟",
            "answer": "A",
            "explain": "本题考查ETF基金的信息披露。ETF基金需按交易所的要求，在每日开市前(D选项符合题意)披露当日的申购清单和赎回清单。"
        },
        {
            "title": "基金管理人内部控制要求包括（　　）。",
            "question": "A. II、III、IV\nB. I、II\nC. I、II、III、IV\nD. I",
            "questions": "I. 严格控制基金财产财务风险<br>II. 建立完善的信息披露制度<br>III. 建立严格的信息技术管理制度<br>IV. 建立科学严密的风险管理系统",
            "answer": "C",
            "explain": "本题考查内部控制的要求。基金管理人的内部控制要求部门设置体现权责明确、相互制约的原则；严格授权控制；强化内部监督稽核控制；建立完善岗位责任制度和科学、严格的岗位分离制度；严格控制基金财产财务风险（I项正确）；建立完善的信息披露制度（II项正确）；建立严格的信息技术系统管理制度（III项正确）；建立科学严密的风险管理系统。"
        },
        {
            "title": "关于基金销售渠道审慎调查，以下说法正确的是（　　）。",
            "question": "A. 中国证券投资基金业协会应负责对基金管理人的审慎调查，并将调查结果发送给各基金代销机构\nB. 开展基金销售渠道审慎调查时，调查方不能接受被调查方提供的非公开信息\nC. 基金管理人对基金代销机构进行审慎调查，应将基金代销机构的销售能力作为最主要指标",
            "answer": "C",
            "explain": "本题考查基金销售渠道审慎调查。A选项说法错误，基金销售的适用性要求基金管理人和基金代销机构相互进行审慎调查，故基金代销机构应负责对基金管理人的审慎调查。B选项说法错误，开展审慎调查时若接受被调查方提供的非公开信息使用的，必须对信息的适当性实施尽职甄别，故调查方可以接受被调查方提供的非公开信息。C选项说法正确，基金销售机构在开展审慎调查时，应当尽力减少主观因素和人为因素的干扰，尽量做到客观准确，并且有合理的理论依据。D选项说法错误，基金管理人通过对基金代销机构进行审慎调查，可将调查结果作为选择基金代销机构的重要依据，而非将销售能力作为最主要指标。"
        }, {
            "title": "投资者可以通过下列哪些渠道办理开放式基金的申购与赎回( )。",
            "question": "A. I、III\nB. I、II、III\nC. II、III\nD. I、II",
            "questions": "I. 基金管理人直销中心<br>II. 基金销售代理人的代销网点<br>III. 基金托管机构",
            "answer": "D",
            "explain": "本题考查开放式基金的申购赎回。开放式基金是指基金份额不固定,基金份额可以在基金合同约定的时间和场所进行申购或者赎回的一种基金运作方式。开放式基金的申购和赎回与认购渠道一样，可以通过基金管理人的直销中心与基金销售代理网点进行。也可通过基金管理人或其指定的基金销售代理以电话、传真或互联网等形式进行申购和赎回(但是不能通过基金托管机构赎回)。"
        },
        {
            "title": "以退休养老资金作为投资本金的老年客户A被某证券公司营业部在银行驻点人员B营销至证券公司开户。购买了1万份开放式基金，本以为是保本基金，最近发现亏了2500，于是认为是营业部客户经理欺骗了他的，向监管局进行投诉。经监管局调查发现，营业部银行驻点人员B向客户推荐证券公司代销开放式基金是，向客户递交了两份产品说明书，其中一份为保本型，另一份为股票型，但是客户没有能力详细阅读产品说明书，在推介保本型和股票型基金是，B未做投资者适当性调查，仅靠营业部客户经理介绍分别购买了5000元保本型和股票型基金，结果股票型基金亏损50%，下列案例中B的不当行为包括( )。",
            "question": "A. II、III\nB. I、IV\nC. I、II、III\nD. II、III、IV",
            "questions": "I. 在银行销售基金<br>II. 向以退休养老资本作为投资本金的老年人推荐高风险产品<br>III. 未对客户进行投资者适当性调查<br>IV. 向以退休养老资金作为投资本金的老年人客户推荐保本产品",
            "answer": "A",
            "explain": "本题考查基金销售的适当性原则。"
        },
        {
            "title": "某基金管理人在披露基金年度报告时，仅披露了对信息披露义务人有利的信息，而忽略了对信息披露义务不利的各种风险因素，此行为违反了基金信息披露的( )。",
            "question": "A. 完整性原则\nB. 真实性原则\nC. 公平性原则\nD. 准确性原则",
            "answer": "A",
            "explain": "本题考查基金信息披露的原则。基金披露内容方面应遵循的基本原则有:真实性原则、准确性原则、完整性原则、及时性原则和公平性原则，基金管理人仅披露有利信息，而忽略不利风险因素，属于没有完整披露信息，违反了基金信息披露的完整性原则。"
        },
        {
            "title": "基金销售机构在受理普通投资者转化为专业投资者申请时，下列行为不适当的是（　　）。",
            "question": "A. 要求投资者提供金融资产证明\nB. 要求投资者提供收入证明\nC. 有义务向普通投资者说明，只有成为专业投资者，才可以投资更多的基金产品，获得更高的回报\nD. 对投资者的专业知识进行考查",
            "answer": "C",
            "explain": "本题考查普通投资者与专业投资者的转化。A、B选项正确，因为普通投资者转化为专业投资者需要满足金融资产或者收入的条件，因此可以要求投资者提供金融资产证明或者收入证明。C选项错误，基金销售机构有义务说明对不同类别投资者履行适当性义务的差别，警示可能承担的投资风险，告知申请的审查结果及其理由。D选项正确，基金销售机构应当通过追加了解信息、投资知识测试或者模拟交易等方式对投资者进行谨慎评估，确认其符合要求。"
        },
        {
            "title": "私募基金募集结算资金专用账户主要用于（　　）。",
            "question": "A. II、III\nB. I、II、III、IV\nC. I、II\nD. II、III、IV",
            "questions": "I. 归集募集结算资金<br>II. 支付赎回款项<br>III. 向投资者分配收益<br>IV. 分配基金清算后的剩余财产",
            "answer": "B",
            "explain": "本题考查私募基金募集结算资金专用账户。销售机构或相关合同约定的责任主体应当开立私募基金募集结算资金专用账户，用于：（1）统一归集私募基金募集结算资金（I项符合题意）：(2）向投资者分配收益(III项符合题意)；（3）给付赎回款项以及分配基金清算后的剩余基金财产等，确保资金原路返还(II. IV项符合题意)。"
        },
        {
            "title": "关于基金管理人的内部控制监督，以下说法正确的是（　　）。",
            "question": "A. I、III\nB. I、II\nC. I、II、III\nD. II、III",
            "questions": "I. 要建立重大决策负责人独立审批制度，以杜绝负责人推卸责任<br>II. 要建立部门之间相互制约的制度，以杜绝部门权力过大或集体徇私舞弊<br>III. 要建立关键岗位管理人员轮岗和定期稽查制度，以杜绝中层经理人员以权谋私或串通作案",
            "answer": "D",
            "explain": "本题考查基金管理人内部控制机制的建设。I项错误，要加强对基金管理人的内部控制监督，建立基金管理人重大决策集体审批制度，以杜绝业务管理层负责人独断专行。II项正确，要加强对基金管理人部门管理的控制监督，建立部门之间相互牵制的制度，以杜绝部门权利过大或集体徇私舞弊。III项正确，要加强对关键岗位管理人员的控制监督，建立关键岗位轮岗和定期稽查制度，以杜绝基金管理人中层经理人员以权谋私或串通作案，从而建立健全企业内部控制监督机制。综上，II. III描述正确。"
        },
        {
            "title": "不负责召集基金份额持有人大会的组织或机构是（　　）。",
            "question": "A. 基金托管人\nB. 基金份额持有人\nC. 基金管理人\nD. 基金销售机构",
            "answer": "D",
            "explain": "本题考查基金份额持有人大会。依据《证券投资基金法》的规定，基金份额持有人大会由基金管理人召集。基金份额持有人大会设立日常机构的，由该日常机构召集;该日常机构未召集的，由基金管理人召集。基金管理人未按规定召集或者不能召集的，由基金托管人召集。代表基金份额10%以上的基金份额持有人就同一事项要求召开基金份额持有人大会，而基金份额持有人大会的日常机构、基金管理人、基金托管人都不召集的，代表基金份额10%以上的基金份额持有人有权自行召集，并报中国证监会备案。"
        },
        {
            "title": "下列事件中需要基金当事人作为重大事件予以临时披露的是（　　）。",
            "question": "A. 基金前十大持仓股票发生连续2次以上跌停\nB. 基金单一持有人的总份额占比超过50%\nC. 自前一个季度未之后基金份额累计变化超过50%\nD. 基金托管人的基金托管部门负责人变更",
            "answer": "D",
            "explain": "本题考查基金临时信息披露的内容。当发生重大事件时，信息披露义务人应当在重大事件发生之日起2日内编制并披露临时报告书。基金重大事件包括：（1）基金份额持有人大会的召开；(2）提前终止基金合同；（3）延长基金合同期限；（4）转换基金运作方式；（5）更换基金管理人或托管人；"
        },
        {
            "title": "中国证监会实行注册管理的基金服务机构包括（　　）。",
            "question": "A. I、II、III、IV\nB. I、II\nC. I、II、III\nD. I、III、IV",
            "questions": "I. 基金销售机构<br>II. 基金销售支付机构<br>III. 基金份额登记机构<br>IV. 基金估值核算机构",
            "answer": "D",
            "explain": "本题考查基金服务机构的注册或者备案。中国证监会对于基金销售机构、基金份额登记机构、基金估值核算机构实行注册管理。中国证监会对于基金销售支付机构、基金投资顾问机构、基金评价机构、基金信息技术系统服务机构实行备案管理。（易混：实行注册管理和实行备案管理的机构注意区分。）I. III. IV项均应实行注册管理。"
        }, {
            "title": "基金销售机构对所代销的股票型基金进行风险评价的主要依据是（　　）。",
            "question": "A. I、III、IV\nB. I、II、IV\nC. II、III、IV\nD. I、II、III、IV",
            "questions": "I. 基金托管人托管规模<br>II. 基金的历史业绩<br>III. 基金净值的波动率<br>IV. 基金的投资范围",
            "answer": "C",
            "explain": "本题考查基金产品或者服务风险评价。基金产品风险评价应当至少依据以下四个因素：一是基金招募说明书所明示的投资方向、投资范围和投资比例；（IV项正确）二是基金的历史规模和持仓比例，三是基金的过往业绩及基金净值的历史波动程度，（II. III项正确）四是基金成立以来有无违规行为发生。同时综合考虑流动性、到期"
        },
        {
            "title": "关于基金信息披露应遵循的基本原则，以下表述错误的是（　　）。",
            "question": "A. 公开披露的信息为一般公共投资者容易获取\nB. 表述应当简明扼要，通俗易懂\nC. 应尽量使用技术性的专业用语\nD. 必须按照法定的内容和格式进行披露",
            "answer": "C",
            "explain": "本题考查基金信息披露应遵循的基本原则。基金披露形式方面应遵循的基本原则有:规范性原则、易解性原则、易得性原则。C选项不符合易解性原则，易解性原则要求信息披露的表述应当简明扼要、通俗易懂，避免使用冗长、技术性用语。"
        },
        {
            "title": "下列不属于ETF申购赎回现金替代类型的是（　　）。",
            "question": "A. 可以现金替代\nB. 禁止现金替代\nC. 必须现金替代\nD. 选择现金替代",
            "answer": "D",
            "explain": "本题考查ETF现金替代。现金替代是指申购和赎回过程中，投资者按基金合同和招募说明书的规定，用于替代组合证券中部分证券的一定数量的现金。现金替代分为三种类型：禁止现金替代、可以现金替代和必须现金替代。"
        },
        {
            "title": "某基金公司的合规部负责人同时兼任投资部负责人，违背了合规管理中的（　　）要求。",
            "question": "A. 合规机制的独立性\nB. 投资部门的独立性\nC. 合规部门的独立性\nD. 问责的独立性",
            "answer": "C",
            "explain": "本题考查合规独立性。合规独立性包括合规部门、机制、问责独立性，其中合规部门的独立性最重要。本题中合规部负责人同时兼任投资部负责人可能导致利益冲突，违背了合规部门的独立性。"
        },
        {
            "title": "关于基金财产的独立性以下表述错误的是（　　）。",
            "question": "A. 契约型基金不具有独立法人地位，因此基金财产不能独立于基金管理人的固有资产\nB. 基金财产的债务由基金财产本身承担，基金份额持有人以其出资为限对基金财产的债务承担责任\nC. 公司型基金在法律上具有独立法人地位，其财产具有独立性\nD. 契约型基金采用的是信托法律原理，信托财产具有独立性",
            "answer": "A",
            "explain": "本题考查基金资产的独立性。A项说法错误、D项说法正确，契约型基金采用的是信托法律原理，信托资产也具有独立性。B项说法正确，基金财产的债务由基金财产本身承担，基金份额持有人以其出资为限对基金财产的债务承担责任。但基金合同依照本法另有约定的从其约定。C项说法正确，公司型基金在法律上具有独立法人地位，其财产具有独立性，是投资基金的重要特征。"
        },
        {
            "title": "操纵市场是违法违规行为，以下涉嫌“操纵市场”的行为包括（　　）。",
            "question": "A. II、III\nB. I、III\nC. I、II\nD. II、III、IV",
            "questions": "I. 利用未公开信息交易<br>II. 实施了企图影响证券价格或人为虚增交易量等不当影响证券价格的行为<br>III. 传播误导市场参与者的信息影响市场价格<br>IV. 利用资金优势联合或连续买卖推高价格",
            "answer": "D",
            "explain": "本题考查操纵市场的概念。操纵市场，是指通过扭曲证券价格形成机制或人为控制交易量等方式而意图误导市场参与者的行为。操纵市场的构成要素有两方面：一是有误导市场参与者的意图，这也是判定是否构成“操纵市场”的关键因素（四项符合题意）。"
        },
        {
            "title": "私募基金管理人、私募基金托管人及私募基金销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录及其他相关资料，法规对保存期限的要求为（　　）。",
            "question": "A. 自基金清算终止之日起不得少于15年\nB. 自基金清算终止之日起不得少于10年\nC. 自基金清算终止之日起不得少于20年\nD. 自基金清算终止之日起不得少于5年",
            "answer": "B",
            "explain": "本题考查私募基金资料的保存。私募基金管理人、私募基金托管人及私募基金销售机构应当妥善保存私募基金投资决策、交易和投资者适当性管理等方面的记录及其他相关资料，保存期限自基金清算终止之日起不得少于10年(B选项符合题意)。"
        },
        {
            "title": "关于公募基金管理公司的董事、监事、高级管理人员的义务，如下表述正确的有（　　）。",
            "question": "A. III\nB. I、III\nC. II、III\nD. I、II、III",
            "questions": "I. 其本人、配偶不得进行证券投资<br>II. 其不得担任基金托管人或者其他基金管理人的任何职务<br>III. 其应当熟悉证券投资方面的法律、行政法规",
            "answer": "C",
            "explain": "本题考查对基金管理人的监管。I项表述错误，基金管理人的董事、监事、高级管理人员和其他从业人员，其本人、配偶、利害关系人进行证券投资，应当事先向基金管理人申报，并不得与基金份额持有人发生利益冲突，而不是不得进行证券投资。"
        },
        {
            "title": "关于基金管理公司风险管理的适时性原则，以下理解正确的是（　　）。",
            "question": "A. I、II\nB. I、III\nC. II、III\nD. I、II、III",
            "questions": "I. 公司应当确保其制定的风险控制制度具有一定前瞻性<br>II. 公司应当根据内部环境的变化及时对风险进行评估<br>III. 公司应当根据外部因素的变化调整其风险管理政策和措施",
            "answer": "D",
            "explain": "本题考查适时性原则。I. II. III项均理解正确，基金公司制度的制定应具有前瞻性，并且必须随着公司经营战略、经营方针、经营管理、组织结构的变化等内部环境的变化和国家法律法规、政策制度等外部环境的改变及时进行相应的修改和完善。"
        }, {
            "title": "基金管理人和基金销售机构为客户提供个性化服务，包括（　　）。",
            "question": "A. I、II\nB. I、III\nC. III、IV\nD. II、III",
            "questions": "I. 利用平时市场走访收集的客户营销资料等方面的信息，对客户的投资活动进行分析<br>II. 与正规金融机构共享客户交易及持仓信息进行分析，通过有针对性的客户服务满足其个性化需求<br>III. 开展实地拜访、现场咨询等特定服务，深度挖掘客户需求<br>IV. 做好客户的参谋，做好市场信息咨询，勇于承担客户投资决策的责任",
            "answer": "B",
            "explain": "本题考查基金客户个性化服务的内容。"
        },
        {
            "title": "关于基金管理公司机构设置的权责明确、相互制约原则，其内涵主要包括（　　）。",
            "question": "A. III、IV\nB. I、II\nC. II、III、IV\nD. I、II、III、IV",
            "questions": "I. 同一高级管理人员，不能同时分管相互冲突的业务<br>II. 公司的重大经营决策应通过管理层会议的方式来审议批准<br>III. 业务部门应通过业务流程相互复核<br>IV. 合规、风险管理部门实施持续的风险管理",
            "answer": "D",
            "explain": "本题考查相互制约和不相容职责分离原则。基金公司管理层、各部门及各级岗位在内部组织结构的设计上应形成权责明确、相互制约的机制，建立部门和岗位之间的制衡机制，消除风险管理盲点，强化全员合规和风险控制。"
        },
        {
            "title": "基金职业道德的核心规范是（　　）。",
            "question": "A. 自觉自律\nB. 保守秘密\nC. 互相监督\nD. 诚实守信",
            "answer": "D",
            "explain": "本题考查的是诚实守信的含义。诚实守信是调整各种社会人际关系的基本准则，诚实守信是基金职业道德的核心规范。"
        },
        {
            "title": "根据《证券投资基金销售管理办法》的规定，关于基金宣传推介材料，以下表述错误的是（　　）。",
            "question": "A. 基金宣传资料在面向特定群体展示时，才可以通过诱导性表述促成客户交易\nB. 基金宣传推介材料必须符合监管机构等出台的相关法规\nC. 基金管理公司和基金销售机构不得在基金宣传资料中夸大产品业绩\nD. 基金宣传资料是投资基金对外展示的平台，也是投资者了解基金的主要渠道",
            "answer": "A",
            "explain": "本题考查基金宣传推介材料。A选项错误，基金宣传资料不管是面向特定群体或公众展示时，都不得通过诱导性表述促成客户交易。"
        },
        {
            "title": "基金管理人应当建立良好的内部治理结构，明确（　　）的职责规范，确保基金各部门的合规运作。",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. I、II、III\nD. I、III、IV",
            "questions": "I. 股东会<br>II. 董事会<br>III. 监事会<br>IV. 高级管理人员",
            "answer": "A",
            "explain": "本题考查对基金管理人内部治理的监管。基金管理人应建立良好的内部治理结构，明确股东会、董事会、监事会和高级管理人员的职责权限，确保基金管理人独立运作。"
        },
        {
            "title": "关于私募基金风险揭示书中所涉及的风险中，以下属于私募基金特殊风险的是（　　）。",
            "question": "A. 资金损失风险\nB. 募集失败风险\nC. 税收风险\nD. 未在中国基金业协会登记备案的风险",
            "answer": "D",
            "explain": "本题考查私募基金的一般风险和特殊风险。私募基金的特殊风险，包括基金合同与中国基金业协会合同指引不一致所涉风险、基金未托管所涉风险、基金委托募集所涉风险、外包事项所涉风险、聘请投资顾问所涉风险、未在中国基金业协会登记备案的风险等。"
        },
        {
            "title": "基金从业人员应遵守保密义务。以下不属于保密内容的是（　　）。",
            "question": "A. 某公募基金的招募说明书\nB. 执业过程中获知的客户商业秘密\nC. 对某一行业的研究报告\nD. 客户的身份证和联系方式",
            "answer": "A",
            "explain": "本题考查保守秘密。保守秘密要求基金从业人员不应泄露或者披露执业活动中接触到的秘密。基金从业人员在执业活动中接触到的秘密主要包括三类：（1）商业秘密，指不为公众所知悉的、能够带来经济利益、具有实用性并被采取保密措施的技术信息和经营信息（B选项属于保密内容）。（2）客户资料，主要是指客户的个人资料，包括客户个人的身份证信息、移动电话号码、家庭成员信息、财务状况、投资需求等（D选项属于保密内容）。"
        },
        {
            "title": "关于基金管理人监察稽核控制的内容，以下说法错误的是（　　）。",
            "question": "A. 基金管理人应当严格规范监察稽核人员的任职条件\nB. 对违反法律法规和公司内部控制制度的有关部门和人员，基金管理人应当追究其责任\nC. 基金管理人应当强化内部检查制度，通过定期或不定期检查内部控制制度的执行情况\nD. 基金管理人督察长应当积极配合股东工作，服从并执行股东下达的指令",
            "answer": "D",
            "explain": "本题考查监察稽核控制。A选项正确，公司应当明确监察稽核部门及内部各岗位的具体职责，配备充足的监察稽核人员，严格监察稽核人员的专业任职条件，严格监察稽核的操作程序和组织纪律。B选项正确，基金管理人董事会和管理层应当重视和支持监察稽核工作，对违反法律法规和公司内部控制制度的，应当追究有关部门和人员的责任。C选项正确，基金管理人应当强化内部检查制度，通过定期或不定期检查内部控制制度的执行情况，确保公司各项经营管理活动的有效运行。"
        },
        {
            "title": "基金销售机构向普通投资者销售最高风险等级的基金产品时，应当向投资者揭示的事项不包括（　　）。",
            "question": "A. 普通投资者诉讼方式及纠纷解决安排\nB. 基金产品的详细信息、重点特征和风险\nC. 该产品的历史业绩和分红情况\nD. 普通投资者可能承担的损失",
            "answer": "C",
            "explain": "本题考查投资者与基金产品或者服务的风险匹配。基金募集机构在向普通投资者销售最高风险等级(R5)的基金产品或者服务时，应向其完整揭示以下事项：（1）基金产品或者服务的详细信息、重点特性和风险；（B选项正确）（2）基金产品或者服务的主要费用、费率及重要权利、信息披露内容、方式及频率；（3）普通投资者可能承担的损失；（D选项正确）（4）普通投资者投诉方式及纠纷解决安排。（A选项正确）"
        }, {
            "title": "关于资产管理的本质，以下表述错误的是（　　）。",
            "question": "A. 活动要求风险和收益相匹配\nB. 必须坚持“实者有责”\nC. 必须坚持“买者自负”\nD. 产品承担保证责任",
            "answer": "D",
            "explain": "本题考查资产管理的本质。资产管理的本质是基于信任而履行受托职责，实现委托人利益最大化，通俗地讲是“受人之托，代人理财”。资产管理的本质具体表现为以下三点：一切资产管理活动都要求风险和收益相匹配管理人必须坚持“卖者有责”；投资人必须做到“买者自负”。综上所述，D选项不属于资产管理的本质。"
        },
        {
            "title": "在基金募集和运作过程中，负有信息披露义务的当事人主要包括（　　）。",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "questions": "I. 基金管理人<br>II. 基金托管人<br>III. 基金经理<br>IV. 召集基金份额持有人大会的基金份额持有人",
            "answer": "D",
            "explain": "本题考查基金主要当事人的信息披露义务。在基金募集和运作过程中，负有信息披露义务的当事人主要有基金管理人、基金托管人、召集基金份额持有人大会的基金份额持有人。他们应当依法及时披露基金信息，并保证所披露信息的真实性、准确性和完整性。不包括基金经理。"
        },
        {
            "title": "关于资产管理的本质，以下表述错误的是（　　）。",
            "question": "A. 活动要求风险和收益相匹配\nB. 必须坚持“卖者有责”\nC. 必须坚持“买者自负”\nD. 产品承担保证责任",
            "answer": "D",
            "explain": "本题考查资产管理的本质。资产管理的本质是基于信任而履行受托职责，实现委托人利益最大化，通俗地讲是“受人之托，代人理财”。资产管理的本质具体表现为以下三点：一切资产管理活动都要求风险和收益相匹配管理人必须坚持“卖者有责”；投资人必须做到“买者自负”。综上所述，D选项不属于资产管理的本质。"
        },
        {
            "title": "在基金募集和运作过程中，负有信息披露义务的当事人主要包括（　　）。",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、III、IV\nD. I、II、IV",
            "questions": "I. 基金管理人<br>II. 基金托管人<br>III. 基金经理<br>IV. 召集基金份额持有人大会的基金份额持有人",
            "answer": "D",
            "explain": "本题考查基金主要当事人的信息披露义务。在基金募集和运作过程中，负有信息披露义务的当事人主要有基金管理人、基金托管人、召集基金份额持有人大会的基金份额持有人。他们应当依法及时披露基金信息，并保证所披露信息的真实性、准确性和完整性。不包括基金经理。"
        },
        {
            "title": "宋先生赎回B基金10000份基金单位，赎回当日基金份额净值为1.350元，赎回费率0.5%，宋先生赎回时总计付出赎回费为（　　）。",
            "question": "A. 67.15\nB. 50\nC. 67.5\nD. 64.25",
            "answer": "C",
            "explain": "本题考查赎回费用的计算。赎回金额=赎回总额=赎回费用；赎回总额=赎回数量×赎回日基金份额净值；赎回费用=赎回总额×赎回费率。由题可知赎回份额=10000份，赎回费率=0.5%，赎回当日基金份额净值=1.350元带入公式可得赎回总额=10000×1.350=13500赎回费用=13500×0.5%=67.5元。C选项符合题意。"
        },
        {
            "title": "关于基金管理公司管理层对风险管理的职责，以下表述错误的是（　　）。",
            "question": "A. 识别、清除公司业务的所有风险\nB. 确保风险管理制度有效执行\nC. 制定与发展战略、整体风险承受能力的风险管理制度\nD. 根据公司风险管理战略和各部门分工，组织实施风险解决方案",
            "answer": "A",
            "explain": "本题考查管理层风险管理职责。公司管理层对有效的风险管理承担直接责任，履行的风险管理职责是：（1）根据董事会的风险管理战略，制定与公司发展战略、整体风险承受能力相匹配的管理制度(C项正确)，并确保风险管理制度全面、有效执行(B项正确)；（2）在董事会授权范围内批准重大事件、重大决策的风险评估意见和重大风险的解决方案，并按章程或董事会相关规定履行报告程序；（3）根据公司风险管理战略和各职能部门与业务单元职责分工，组织实施风险解决方案(D项正确)。"
        },
        {
            "title": "关于担任基金托管人应当具备的条件，以下表述正确的是（　　）。",
            "question": "A. I、II、IV\nB. I、II、III、IV\nC. I、II、III\nD. II、III、IV",
            "questions": "I. 有足够的基金销售网点<br>II. 有符合法定人数要求的，具有基金从业资格的专职人员<br>III. 有安全高效的清算、交割系统<br>IV. 有完善的内部稽核监控制度和风险控制制度",
            "answer": "D",
            "explain": "本题考查担任基金托管人的条件。担任基金托管人的条件：（1）净资产和风险控制指标符合有关规定；"
        },
        {
            "title": "某基金经理在选择基金投资品种时，既选择风险较低、收益稳定的债券，也选择收益较高，风险较大的股票，这体现了证券投资基金（　　）的特点。",
            "question": "A. 利益共享、风险共担\nB. 严格监管、信息透明\nC. 组合投资、分散风险\nD. 集合理财、专业管理",
            "answer": "C",
            "explain": "本题考查证券投资基金特点。在多数情况下，某些股票价格下跌造成的损失可以用其他股票价格上涨产生的股利来弥补，因此可以充分享受到组合投资、分散风险的好处(C选项符合题意)。该经理既选择风险较低的债券，也选择收益较高的股票，就是为了组合投资、分散股票的风险。C选项符合题意。"
        },
        {
            "title": "下列关于道德与法律的调整范围的表述，错误的是（　　）。",
            "question": "A. 法律的调整对象侧重于人们的外在行为和结果的合法化\nB. 法律的调整对象包括人们的思想和动机\nC. 法律调整的范围不如道德调整的范围广泛\nD. 道德可以调整人们内在的精神世界和心理动机",
            "answer": "B",
            "explain": "本题考查道德与法律的区别与联系。A项说法正确，法律调整的对象侧重于人们的外在行为和结果的合法化，具有较强的客观性。B项说法错误，D项说法正确，道德调整的范围比法律调整的范围更为广泛，不仅要调整人们的外在行为和结果，还要调整人们内在的精神世界和心理动机。法律不调整人们的思想和动机。"
        }, {
            "title": "关于基金交易业务控制的描述，以下说法正确的是（　　）。",
            "question": "A. 公司应当对重要客户执行公平的交易分配制度，确保重要客户的利益能够得到公平对待\nB. 基金投资涉及关联交易的，应在相关投资研究报告中特别说明，并报公司相关机构批准\nC. 基金投资指令采用先执行后报备审核制度，每日投资信息均需及时核对与归档\nD. 基金交易应实行集中交易制度，由基金经理向交易员直接下达交易指令",
            "answer": "B",
            "explain": "本题考查基金交易业务控制的主要内容。A选项说法错误，公司应当执行公平的交易分配制度，确保各种投资者的利益能够得到公平对待，而不仅仅重要客户。B选项说法正确，基金投资涉及关联交易的，应在相关投资研究报告中特别说明，并报公司相关机构批准。C选项说法错误，基金投资指令应当进行审核，确认其合法、合规与完整后方可执行。D选项说法错误，基金交易应实行集中交易制度，基金经理不得直接向交易员下达投资指令或者直接进行交易。"
        },
        {
            "title": "关于基金托管人的法定职责，以下表述错误的是（　　）。",
            "question": "A. 办理与基金财产管理业务活动有关的日常信息披露事项\nB. 对不同基金财产分别设置账户\nC. 复核基金资产净值\nD. 按照规定召集基金份额持有人大会",
            "answer": "A",
            "explain": "本题考查基金托管人的职责。A项符合题意，基金管理人(并不是基金托管人)主要负责办理与基金财产管理业务活动有关的信息事项，具体涉及基金募集、上市交易、净值披露等环节。"
        },
        {
            "title": "关于对开放式基金出现巨额赎回的处理，以下表述错误的是（　　）。",
            "question": "A. 对于超过10%部分赎回申请当日未办理的赎回份额，可按发生巨额赎回当日的价格，延迟至下一个开放日办理\nB. 对于超过10%部分赎回申请，可延迟至下一个开放日办理，转入下一个开放日办理的赎回申请，不享有赎回优先权\nC. 基金管理人在当日接受赎回比例不得低于上一日基金总份额的10%，对其余额回申请可以延期办理\nD. 当发生巨额赎回时，基金管理人应当通知基金份额持有人，说明有关处理方法，同时在指定信息披露媒体公告",
            "answer": "A",
            "explain": "本题考查开放式基金的巨额赎回。单个开放日基金净赎回申请超过基金总份额的10%时，为巨额赎回。A选项表述错误，对于超过10%部分赎回申请当日未办理的赎回份额，可按下一个开放日的基金份额净值为基准计算赎回金额，延迟至下一个开放日办理。"
        },
        {
            "title": "根据《证券投资基金法》的规定，以下各事项中属于公募证券投资基金的招募说明书必信内容的是（　　）。",
            "question": "A. 基金从事证券交易的清算交收安排\nB. 基金投资各类证券指令的发送和执行\nC. 基金管理人和托管人基本情况\nD. 律师事务所为基金募集出具的法律意见书",
            "answer": "C",
            "explain": "本题考查基金招募说明书的披露事项。C选项为必备内容，招募说明书包括基金管理人和基金托管人的基本情况。"
        },
        {
            "title": "以下不属于基金信息披露义务人应当发布基金澄清公告的情形的是（　　）。",
            "question": "A. 基金管理人发现不法分子冒用其旗下基金的名义，通过微信群、App客户端等方式编造投资者资金\nB. 基金管理人发现被主流媒体频繁曝光的某重污染企业的字号与其相同，认为对其品牌和商誉构成不利影响\nC. 基金管理人发现有多家媒体报道或转载某面临重大使用风险的债券的不实报道，且基金持仓中含有该只债券\nD. 基金管理人发现有媒体发布关于基金管理人面临重大财务危机的不实报道",
            "answer": "B",
            "explain": "本题考查基金澄清公告。在基金合同期限内，任何公共媒体中出现的或者在市场上流传的消息可能对基金份额价格或者基金投资者的申购、赎回行为产生误导性影响的，相关信息披露义务人知悉后应当立即对消息进行公开澄清。A、C、D选项属于应发布的情形，会对基金份额价格或者基金投资者的申购、赎回行为产生误导性影响。"
        },
        {
            "title": "私募基金通过以下媒介渠道推介私募基金，其中符合规定的是（　　）。",
            "question": "A. 设置特定合格投资者为对象的微信朋友圈\nB. 公益性开放式讲座报告会\nC. 可公开浏览的私募基金管理人官方网站\nD. APP等公开信息发布平台",
            "answer": "A",
            "explain": "本题考查私募基金的宣传推介。私募基金，是指以非公开方式向投资者募集资金设立的投资基金。私募基金不得通过下列媒介渠道推介私募基金：募集机构及其从业人员推介私募基金时，禁止有以下行为：公开推介或者变相公开推介，如通过报刊、电台、电视、互联网等公众传播媒体，讲座(B选项错误)、报告会、分析会等方式，布告、传单、短信、微信、博客和电子邮件等载体(D选项错误)，向不特定对象宣传具体产品，但证券期货经营机构和销售机构通过设置特定对象确定程序的官网、客户端等互联网媒介向已注册特定对象进行宣传推介的除外。"
        },
        {
            "title": "某投资人赎回某开放式混合型基金C类基金份额(收取赎回费)，持有期为20日，收取的赎回费100元该赎回费计入基金财产的金额为（　　）。",
            "question": "A. 25元\nB. 50元\nC. 100元\nD. 75元",
            "answer": "C",
            "explain": "本题考查赎回费。对于收取赎回费的一般股票型和混合型基金赎回费归属基金财产比例的规定为：持续持有期少于30日的投资人收取不低于0.5%的赎回费，并将上述赎回费全额计入基金财产。由题可知，持有期为20日，故应将赎回费全额计入基金财产。"
        },
        {
            "title": "非交易过户不包括（　　）。",
            "question": "A. 继承\nB. 转换\nC. 司法强制执行\nD. 捐赠",
            "answer": "B",
            "explain": "本题考查开放式基金非交易过户。开放式基金非交易过户是指不采用申购、赎回等基金交易方式，将一定数量的基金份额按照一定规则从某一投资者基金账户转移到另一投资者基金账户的行为，主要包括继承(包括A选项)、司法强制执行(包括C选项)和捐赠(包括D选项)等方式。接受划转的主体必须是合格的个人投资者或机构投资者。A选项描述正确，继承是指依法承受后人的资产，因此所属关系发生变化。"
        },
        {
            "title": "以下不符合基金销售适用性与投资者适当性要求的行为是（　　）。",
            "question": "A. II、III、IV\nB. I、II、III、IV\nC. I、II、IV\nD. I、II、III",
            "questions": "I、基金销售机构要建立健全普通投资者回访机制，但对持有最高风险等级基金产品的投资者要减少回访的比例和频次\nII、基金募集机构在销售高风险的产品时，可以从市场预判的角度向投资者提供确定性的判断\nIII、风险承受能力为C5类型的客户可以购买所有风险等级的产品\nIV、基金销售机构与投资者发生纠纷时，举证责任由投资者承担",
            "answer": "C",
            "explain": "本题考查基金销售适用性与投资者适当性。"
        },
        {
            "title": "守法合规是基金从业人员职业道德的最为基础的要求。从业人员应遵守（　　）。",
            "question": "A. I、II、III\nB. I、II\nC. I\nD. I、II、III、IV",
            "questions": "I. 宪法、刑法、民法等所有公民都需要遵守的法律<br>II. 证监会发布的各类部门规章<br>III. 基金公司内部工作规程<br>IV. 行业协会、交易所发布的自律性业务规则",
            "answer": "D",
            "explain": "本题考查守法合规的含义。守法合规是指基金从业人员不但要遵守法律法规和部门规章，还应遵守与基金业相关的自律规则及其所属机构的各种管理规范，并配合基金监管机构的监管。守法合规中的“法”和“规”包括："
        },
        {
            "title": "关于开放式基金的申购赎回原则，投资者甲认为，包括股票基金，债券基金和货币基金在内的所有开放式基金，在申购赎回时都遵循未知价交易原则，投资者乙认为，开放式基金的申购赎回都遵循份额申购、金额赎回的原则。关于两位投资者的观点，下列判断正确的是（　　）。",
            "question": "A. 甲的观点错误，乙的观点正确\nB. 甲的观点正确，乙的观点错误\nC. 甲、乙的观点都正确\nD. 甲、乙的观点都不正确",
            "answer": "C",
            "explain": "本题考查开放式基金申购和赎回的原则。开放式基金申购和赎回的原则为：（1）股票基金、债券基金：未知价、金额申购、份额赎回原则；（2）货币市场基金：确定价、金额申购、份额赎回原则。"
        },
        {
            "title": "关于违法失信，以下表述正确的是（　　）。",
            "question": "A. 违法失信信息在诚信档案中的效力期限为5年\nB. 因证券期货违法行为被市场禁入的信息效力期限为15年\nC. 超过效力期限的违法失信信息，不再进行诚信信息公开但继续接受诚信信息申请查询\nD. 违法失信信息的效力期限自对违法失信行为的处理决定执行完毕之日起算",
            "answer": "D",
            "explain": "本题考查《证券期货市场诚信监督管理办法》相关规定。A项说法错误，违法失信信息，在诚信档案中的效力期限为3年，并不是5年。B项说法错误，因证券期货违法行为被行政处罚、市场禁入、刑事处罚和判决承担较大侵权、违约民事赔偿责任的信息，其效力期限为5年，并不是15年。C项说法错误，超过效力期限的违法失信信息，不再进行诚信信息公开，并不再接受诚信信息申请查询。"
        },
        {
            "title": "在基金临时信息披露时，信息披露义务人应当在重大事件发生之日起（　　）日内编辑并披露临时报告书。",
            "question": "A. 5\nB. 2\nC. 3\nD. 1",
            "answer": "B",
            "explain": "本题考查基金临时报告。如果预期某种信息可能对基金份额持有人权益或者基金份额的价格产生重大影响，则该信息为重大信息，相关事件为重大事件，信息披露义务人应当在重大事件发生之日起2日内编制并披露临时报告书。"
        },
        {
            "title": "关于货币市场基金宣传推介的规定，以下表述正确的是（　　）。",
            "question": "A. I、II、III、IV\nB. I、II、IV\nC. II、III、IV\nD. I、II、III",
            "questions": "I. 不得使用与货币市场基金风险收益特征不相匹配的表述<br>II. 不得夸大或者片面宣传货币市场基金的投资收益或者过往业绩<br>III. 不得向投资者提供快速赎回等增值服务的，不得披露增值服务的限制条件<br>IV. 不得明示、比较货币市场基金与银行存款及其他产品的投资收益",
            "answer": "B",
            "explain": "本题考查货币市场基金宣传推介的规定。"
        },
        {
            "title": "以下不属于基金法定信息披露范畴的是（　　）。",
            "question": "A. 基金招募说明书\nB. 基金投资预测说明书\nC. 基金合同\nD. 基金托管协议",
            "answer": "B",
            "explain": "本题考查基金信息披露的内容。基金信息披露是指基金市场上的有关当事人在基金募集、上市交易、投资运作等一系列环节中，依法向社会公众进行的信息披露。基金信息披露的内容包括：（1）基金招募说明书(A选项符合题意)、基金合同(C选项符合题意)、基金托管协议(D选项符合题意)；"
        },
        {
            "title": "下列基金公司基金销售活动中不属于直销业务的是（　　）。",
            "question": "A. 基金公司销售人员开发高净值个人客户\nB. 基金公司通过自主开发建立的电子商务平台销售基金产品\nC. 基金公司销售人员维护机构客户\nD. 基金公司渠道经理通过商业银行销售基金产品",
            "answer": "D",
            "explain": "本题考查基金销售机构的类型。基金公司开展直销目前主要包括两种形式：（1）专门的销售人员直接开发(A选项属于直销业务)和维护机构客户(C选项属于直销业务)和高净值个人客户。(2）自行开发建立电子商务平台(B选项属于直销业务)。D选项通过商业银行销售基金产品属于代销业务。"
        },
        {
            "title": "关于基金管理人的职责，以下说法正确的是（　　）。",
            "question": "A. 基金管理人可以将基金资产的投资运作委托给其他服务机构承担\nB. 基金管理人可以对基金份额持有人大会议审议事项行使表决权\nC. 基金管理人可以将基金产品的设计职能委托给其他服务机构\nD. 基金管理人可以将基金产品的设计职能委托给其他服务机构",
            "answer": "D",
            "explain": "本题考查基金管理人的职责。A项说法错误，基金管理人的最主要职责就是按照基金合同的约定，负责基金资产的投资运作，在有效控制风险的基础上为基金投资者争取最大的投资收益，管理人在基金运作中具有核心作用。B项说法错误，"
        },
        {
            "title": "某基金公司员工甲认为，董事会对风险管理的有效性承担最终责任，可以授权其下设的专门委员会履行相应的风险管理和监督职责，员工乙认为，公司管理层对风险管理的有效性承担直接责任，为了协助管理层履行风险管理职能，可以设立履行风险管理职能的委员会，针对两位员工的看法，下列判断正确的是（　　）。",
            "question": "A. 员工甲的看法正确，员工乙的看法正确\nB. 员工甲的看法正确，员工乙的看法错误\nC. 员工甲的看法错误，员工乙的看法错误\nD. 员工甲的看法错误，员工乙的看法正确",
            "answer": "A",
            "explain": "本题考查董事会的风险管理职责。甲的看法正确，乙的看法正确。董事会对有效的风险管理承担最终责任，可以授权其下设的专门委员会履行相应的风险管理和监督职责，公司管理层对风险管理的有效性承担直接责任，为了协助管理层履行风险管理职能，可以设立履行风险管理职能的委员会。"
        }, {
            "title": "基金管理公司和基金代销机构进行基金宣传推介，应按照规定报送报告材料，报告材料包括（　　）。",
            "question": "A. II、III、IV\nB. I、II、III\nC. I、II、IV\nD. I、II、III、IV",
            "questions": "I. 基金宣传推介材料的形式和用途说明<br>II. 基金公司督察长出具的合规意见书<br>III. 基金代销机构出具的基金评级报告<br>IV. 基金托管银行出具的基金业绩复核函",
            "answer": "C",
            "explain": "本题考查宣传推介材料审批报备的相关规定。"
        },
        {
            "title": "关于QDII基金与普通开放式基金的相同点和区别，以下表述错误的是（　　）。",
            "question": "A. 投资者同时赎回QDII基金和普通开放式基金，一般情况下QDII基金的赎回款先收到\nB. QDII基金申购和赎回的币种可以是人民币或其他币种;普通开放式基金通常只能是人民币\nC. 两者申购和赎回一股都可以通过直销和代销渠道进行\nD. 两者发生巨额赎回时的处理方法类似",
            "answer": "A",
            "explain": "本题考查QDII基金与一般开放式基金的申购赎回。A选项表述错误，对于开放式基金而言，赎回申请成功后，基金管理人应当自受理基金投资者有效赎回申请之日起7个工作日内支付赎回款项;对QDII基金而言，赎回申请成功后，基金管理人将在T+10日内支付赎回款项。所以，普通开放式基金的赎回款先收到。"
        },
        {
            "title": "某基金宣传材料有以下内容：基金单位净值达到1.110元后开放申购，基金公司销售人员向投资者承诺基金会净值归一，以便投资者在同一起跑线上享受投资收益，欲购从速。“以下表述正确的是（　　）。",
            "question": "A. 净值归一符合保护投资者原则\nB. 不可以使用“欲购从速”强调集中营销的表述\nC. 销售人员的承诺不属于业绩承诺，不构成违规承诺\nD. 在不损害投资者权益的前提下，可以使用净值归一作为基金推介方式",
            "answer": "B",
            "explain": "本题考查基金宣传推介材料的禁止性规定。A选项表述错误，基金宣传推介材料禁止使用“净值归一”“欲购从速”等误导基金投资人的表述。B选项表述正确，基金宣传推介材料禁止使用“欲购从速”等强调集中营销的表述。"
        },
        {
            "title": "当开放式基金出现巨额赎回时，以下有可能导致部分延期赎回的是（　　）。",
            "question": "A. 基金资产组合中，现金类资产配置较少\nB. 基金资产组合中，重仓股持续停牌中\nC. 托管人认为兑付全部赎回申请可能使基金份额净值发生较大波动\nD. 基金资产组合中，可快速变现资产较少，不足以对付全额赎回申请",
            "answer": "D",
            "explain": "本题考查巨额赎回。巨额赎回是指单个开放日基金净赎回申请超过基金总份额的10%时，部分延期赎回的条件:当管理人认为兑付投资者的赎回申请有困难，或认为兑付投资者的赎回申请进行的资产变现可能使基金份额净值发生较大波动时，基金管理人可在当日接受顾问比例不低于上一日基金总份额10%的前提下，对其余顾问申请延期办理。"
        },
        {
            "title": "在基金管理人内部控制监督机制上，以下描述正确的是（　　）。",
            "question": "A. I、II、III\nB. II、III、IV\nC. I、II、III、IV\nD. I、III、IV",
            "questions": "I. 建立基金管理人重大决策集体审批制度<br>II. 建立部门之间互相管理监督的制度<br>III. 加强对关键岗位管理人员的控制监督<br>IV. 建立关键岗位轮岗和定期检查制度",
            "answer": "D",
            "explain": "本题考查基金管理人内部控制机制的建设。"
        },
        {
            "title": "基金管理人之间制定内部控制制度一般应当遵循（　　）。",
            "question": "A. I、II、IV\nB. I、II、III、IV\nC. II、III、IV\nD. I、III",
            "questions": "I. 合法、合规性原则<br>II. 全面性原则<br>III. 审慎性原则<br>IV. 适时性原则",
            "answer": "B",
            "explain": "本题考查内部控制制度制定的原则。"
        },
        {
            "title": "关于基金的关联交易，以下说法正确的是（　　）。",
            "question": "A. 基金投资可以进行关联交易，但要有流程防止不正当关联交易损害持有人利益\nB. 基金管理人应当建立严格有效的投资管理业务制度，严禁重大关联交易\nC. 基金投资涉及关联交易的，只需在相关投资推介告中特别说明即可\nD. 基金投资涉及关联交易的，需事先向监管机构申报",
            "answer": "A",
            "explain": "本题考查基金关联交易的相关内容。"
        },
        {
            "title": "关于基金的募集，基金管理人需要在收到核准文件之日起（　　）个月内进行基金份额的发售。",
            "question": "A. 1\nB. 3\nC. 6",
            "answer": "C",
            "explain": "本题考查基金份额的发售。"
        },
        {
            "title": "一只QDII基金拟投资美国政府债券，委托美国一家托管人对资金进行托管，对于该基金合同的信息披露，以下说法错误的是（　　）。",
            "question": "A. 应当披露托管人的成立时间和法定代表人\nB. 应当披露托管人最近一个季度实收资本、托管资产规模和信用等级\nC. 应当披露托管人主要负责人的教育背景、从业经历\nD. 应当披露托管人名称和办公地址",
            "answer": "C",
            "explain": "本题考查QDII基金的信息披露。"
        }, {
            "title": "关于对基金普通投资者的保护，以下说法错误的是（　　）。",
            "question": "A. 通过基金销售机构向普通投资者进行有关告知和警示时，应当布置全程录音或录像等留痕安排\nB. 普通投资者在信息告知、风险警示、适当性匹配等方面享有特别保护\nC. 当普通投资者与销售机构发生适当性有关的纠纷时，由销售机构提供相关证明以证明其已向投资者履行相应义务\nD. 销售机构可以向普通投资者主动推介不符合其投资目标的产品，但必须事先征得普通投资者的同意",
            "answer": "D",
            "explain": "本题考查对基金普通投资者的保护。基金销售机构不得向普通投资者主动推介风险等级高于其风险承受能力的产品或者服务；不得向普通投资者主动推介不符合其投资目标的产品或者服务；不得向风险承受能力最低类别的普通投资者销售风险等级高于其风险承受能力的产品或者服务。"
        },
        {
            "title": "信托(契约)型证券投资基金的当事人不包括（　　）。",
            "question": "A. 基金管理人\nB. 基金托管人\nC. 监管机构和行业自律组织\nD. 基金投资者",
            "answer": "C",
            "explain": "本题考查信托契约型基金的当事人。信托契约型基金的当事人有:基金投资者、基金托管人、基金管理人。C选项错误，基金监管机构和行业自律组织不属于当事人。"
        },
        {
            "title": "公募基金中需要基金托管人出具托管人报告的是（　　）。",
            "question": "A. II、III、IV\nB. III、IV\nC. I、II、III、IV\nD. I、II、IV",
            "questions": "I. 月度报告<br>II. 季度报告<br>III. 中期报告<br>IV. 年度报告",
            "answer": "B",
            "explain": "本题考查基金报告。在基金半年度报告(中期报告)(II项正确)及年度报告(IV项正确)中出具托管人报告,对报告期内托管人是否尽职尽责以及管理人是否遵规守约等情况做出声明。II. IV项均符合题意。"
        },
        {
            "title": "根据《公开募集证券投资基金管理人监督管理办法》和《基金管理公司子公司管理规定》的规定，公募证券投资基金管理公司可以设立专业子公司经营（　　）。",
            "question": "A. 基金托管业务\nB. 投资顾问业务\nC. 特定客户资产管理业务\nD. 基金份额登记业务",
            "answer": "C",
            "explain": "本题考查基金管理公司及其子公司资产管理业务。根据《中华人民共和国证券投资基金法》、《证券投资基金管理公司管理办法》、《基金管理公司特定客户资产管理业务试点办法》和《基金管理公司子公司管理规定》等法律法规，基金管理公司可以从事公司证券投资基金的募集和管理业务，还可以从事特定客户资产管理业务即非公开募集证券投资基金业务。"
        },
        {
            "title": "甲原为某基金公司销售人员，从业期间获得基金从业资格，后甲从该基金公司辞职，于某房产机构从事房产销售工作，甲在销售房产的同时帮助其原基金公司同事向客户推介该基金公司的基金产品，关于甲的这一行为，以下表述正确的是（　　）。",
            "question": "A. 甲从事基金销售工作时，已经取得过基金从业资格，因此甲可以销售基金\nB. 甲未在专业基金销售机构总部及营业网点宣传推介基金，因此甲不得销售基金\nC. 甲从事过基金销售，具备从事基金销售活动所必需的专业知识，因此甲可以销售基金\nD. 甲目前已不受基金管理人或者基金销售机构聘任，因此甲目前不得推介基金",
            "answer": "D",
            "explain": "本题考查专业审慎。非基金销售机构人员不能销售基金，基金销售要求持证上岗，取得基金从业资格，并经由所在机构向基金业协会申请执业注册后，方可执业。"
        },
        {
            "title": "基金经理王某在渠道交流中透露其投资计划以促进其产品销售，私募基金销售人员李某得知该信息后，提前购买了王某拟投资的股票。王某的行为主要违反了《私募投资基金监督管理暂行办法》规定不得有行为中的（　　）。",
            "question": "A. 泄露内幕信息、从事内幕交易\nB. 利用未公开信息明示、暗示他人从事相关的交易活动\nC. 泄露因职务便利获取的未公开信息\nD. 利用职务之便，为本人或投资者以外的人牟取利益，进行利益输送",
            "answer": "B",
            "explain": "本题考查私募基金相关当事人的禁止性行为。私募基金从业人员从事私募基金业务，不得泄露因职务便利获取的未公开信息，利用该信息从事或者明示、暗示他人从事相关的交易活动。"
        },
        {
            "title": "(材料题)某资产管理有限公司为在中国证券投资基金业协会登记的私募证券基金管理人，旗下管理一只契约型基金。中国证监会在20×8年9月对该公司进行了现场检查，发现以下事实：",
            "questions": "I. 该基金投资者中包括一位自然人投资者，该投资者认购时提供了某券商10个工作日内出具的持有100万元该券商旗下资产管理计划证明<br>II. 管理人委托第三方机构对该基金进行风险评级，产品评级为高风险，投资者风险承受能力为稳健型至进取型不等<br>III. 该基金投资者中包括一个机构投资者，该投资者认购时提供了最近一期财务报表，其净资产为1000万元<br>IV. 原合规风控负责人于20X8年5月离职，该基金管理人尚未向中国证券投资基金业协会更新这一变动，管理人表示该岗位尚未有合适人选，目前空缺，拟尽快招募到合适人选后向中国证券投资基金业协会提交重大事项报告<br>(1）中国证监会对该资产管理有限公司现场检查发现的事实中，属于内控管理缺陷的是 （　　）。",
            "question": "A. I、II\nB. II、III、IV\nC. I、III、IV\nD. I、II、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "(材料题)某资产管理有限公司为在中国证券投资基金业协会登记的私募证券基金管理人，旗下管理一只契约型基金。中国证监会在20×8年9月对该公司进行了现场检查，发现以下事实：",
            "questions": "I. 某高校基金会<br>II. 某保险资管发行的资产管理计划<br>III. 某券商发行的资产管理计划<br>IV. 自然人投资者<br>(2）某资产管理有限公司可向 （　　）推介该契约型基金。",
            "question": "A. I、II、III\nB. I、II、III、IV\nC. I、IV\nD. II、III",
            "answer": "A",
            "explain": ""
        },
        {
            "title": "(材料题)某资产管理有限公司为在中国证券投资基金业协会登记的私募证券基金管理人，旗下管理一只契约型基金。中国证监会在20×8年9月对该公司进行了现场检查，发现以下事实：\n（3）若契约型基金已有198名投资者，则该基金还可接受（　　）作为投资者(假设均满足合格投资者条件)。",
            "question": "A. 6名合伙人的有限合伙企业\nB. 15名股东的有限责任公司\nC. 3名自然人投资者\nD. 10名自然人投资者成立的契约型基金",
            "answer": "B",
            "explain": ""
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2024/5/flfg-4.js